import React from "react";
import Modal from "../../../../components/modal";
import { FooterButtons } from "../../../../components/modal/footerButtons";
import { ModalButton } from "../../../../components/modal/modalButton";
import { Chevron } from "../../../../components/icons";

export const ManageMyRepaymentModal = (props) => {

  return (
    <Modal
      visible={props.visible}
      header={props.header}
      closeable={true}
      size="medium"
      footer={
        <FooterButtons center>
          <ModalButton onClick={props.close}>
            Close
            <Chevron right width="10px" className="button-icon-right" />
          </ModalButton>
        </FooterButtons>
      }
      onClose={props.close}
    >
      {props.children}
    </Modal>
  );
};